import React, { useState, useMemo } from "react";
import "./Verify.css";

// Sample data with "DepositType" instead of Action mapping
const VerifyData = [
  {
    sn: 1,
    DepositType: "Fixed Deposit", // was Active
    CusName: "Ram",
    CusId: "12",
    guardian: "Ramesh Kumar",
    SchemeName: "FD Scheme A",
    DepositAmount: "1000",
    KycStatus: "Approved",
    ReferenceNumber: "20230801",
    RequestedBy: "Manager A",
    RequestedDate: "01/02/2021",
  },
  {
    sn: 2,
    DepositType: "Recurring Deposit", // was Close
    CusName: "Raju",
    CusId: "1234",
    guardian: "Ramesh Kumar",
    SchemeName: "RD Scheme B",
    DepositAmount: "5000",
    KycStatus: "Approved",
    ReferenceNumber: "20230904",
    RequestedBy: "Manager A",
    RequestedDate: "01/02/2022",
  },
  {
    sn: 3,
    DepositType: "Saving Account", // was Pre-Closed
    CusName: "Sita",
    CusId: "5678",
    guardian: "Ram Kumar",
    SchemeName: "SA Scheme C",
    DepositAmount: "3000",
    KycStatus: "Pending",
    ReferenceNumber: "20231005",
    RequestedBy: "Manager B",
    RequestedDate: "05/03/2023",
  },
  
];

const tabMapping = {
  All: "All",
  "Fixed Deposit": "Fixed Deposit",
  "Recurring Deposit": "Recurring Deposit",
  "Saving Account": "Saving Account",
  
};

const Verify = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  const rowsPerPage = 2;

  // Filtered Data
  const filteredData = useMemo(() => {
    let data =
      activeTab === "All"
        ? VerifyData
        : VerifyData.filter((item) => item.DepositType === activeTab);

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .map((val) => (val ? val.toString() : ""))
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    return data;
  }, [activeTab, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData =
    activeTab === "All"
      ? filteredData.slice(
          (currentPage - 1) * rowsPerPage,
          currentPage * rowsPerPage
        )
      : filteredData.slice(0, 5); // Show only 5 rows for other tabs

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    setSelectedRow(null);
  };

  return (
    <div className="Verifyreport-container">
      {/* Tabs */}
      <div className="Verifytabs">
        {Object.keys(tabMapping).map((tab) => (
          <button
            key={tab}
            className={`Verifytab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => handleTabChange(tab)}
          >
            {tabMapping[tab]}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="Verifysearch-box">
        <input
          type="text"
          placeholder="Search by any field..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {/* Table */}
      <div className="Verifytable-container">
        <table className="Verifyreport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Reference Number</th>
              <th>Cus Name</th>
              <th>Cus Id</th>
              {activeTab === "All" ? (
                <>
                  
                  <th>Guardian/Father/husband/Care of</th>
                  <th>Deposit Amount</th>
                  <th>Kyc Status</th>
                  <th>Deposit Type</th>
                  <th>Requested By</th>
                  <th>Requested Date</th>
                  <th> Share</th>
                  <th> Deposite Bond</th>
                </>
              ) : (
                <th>View</th>
              )}
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item) => (
                <tr key={item.sn}>
                  <td>{item.sn}</td>
                  <td>{item.ReferenceNumber}</td>
                  <td>{item.CusName}</td>
                  <td>{item.CusId}</td>
                  {activeTab === "All" ? (
                    <>
                      
                      <td>{item.guardian}</td>
                      <td>{item.DepositAmount}</td>
                      <td>{item.KycStatus}</td>
                      <td>{item.DepositType}</td>
                      <td>{item.RequestedBy}</td>
                      <td>{item.RequestedDate}</td>
                       <td style={{ textAlign: "center" }}>
                  <button
                    className="sharescerti-sub"
                    onClick={() =>
                      alert(`Generating Share Certificate for ${item.name}`)
                    }
                  >
                     Certificate
                  </button>
                </td>
                <td style={{ textAlign: "center" }}>
                  <button
                    className="verifybond-sub"
                    onClick={() =>
                      alert(`Generating Deposit Bond Certificate for ${item.name}`)
                    }
                  >
                     Certificate
                  </button>
                </td>
                    </>
                  ) : (
                    <td>
                      <button
                        className="Verifyview-btn"
                        onClick={() => setSelectedRow(item)}
                      >
                        View
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination only for All tab */}
      {activeTab === "All" && (
        <div className="Verifypagination">
          <button
            onClick={() => setCurrentPage((prev) => prev - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            onClick={() => setCurrentPage((prev) => prev + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </button>
        </div>
      )}

      {/* PDF Style Detail View */}
      {activeTab !== "All" && selectedRow && (
        <div className="Verifypdf-style-card">
          <h3>Verify Account</h3>
          <table className="Verifypdf-style-table">
            <tbody>
              <tr>
                <td>
                  <strong>SN</strong>
                </td>
                <td>{selectedRow.sn}</td>
                <td>
                  <strong>Deposit Type</strong>
                </td>
                <td>{selectedRow.DepositType}</td>
              </tr>
              <tr>
                <td>
                  <strong>Cus Name</strong>
                </td>
                <td>{selectedRow.CusName}</td>
                <td>
                  <strong>Cus Id</strong>
                </td>
                <td>{selectedRow.CusId}</td>
              </tr>
              <tr>
                <td>
                  <strong>Guardian/Father/husband/Care of</strong>
                </td>
                <td>{selectedRow.guardian}</td>
                <td>
                  <strong>Scheme Name</strong>
                </td>
                <td>{selectedRow.SchemeName}</td>
              </tr>
              <tr>
                <td>
                  <strong>Deposit Amount</strong>
                </td>
                <td>{selectedRow.DepositAmount}</td>
                <td>
                  <strong>Kyc Status</strong>
                </td>
                <td>{selectedRow.KycStatus}</td>
              </tr>
              <tr>
                <td>
                  <strong>Reference Number</strong>
                </td>
                <td>{selectedRow.ReferenceNumber}</td>
                <td>
                  <strong>Requested By</strong>
                </td>
                <td>{selectedRow.RequestedBy}</td>
              </tr>
              <tr>
                <td>
                  <strong>Requested Date</strong>
                </td>
                <td>{selectedRow.RequestedDate}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Verify;
